// Application
export const APP_VERSION = "0.2.17";